export default __webpack_public_path__ + "static/font-82d977fea960f83c62bc5524901b98b1.eot";